import {useParams} from 'react-router-dom';
import {
    Alert,
    Grid,
} from '@mantine/core';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile.tsx';
import {DetailPageNavigation} from '../navigation/DetailPageNavigation.tsx';
import {useTestObservation} from '../hooks/useTestObservation.ts';

// FNP-861: READ-ONLY detail view of a single observation. No edit mode and no tools
// — the executor owns the lifecycle.
export const DetailPage = () => {

    const {id} = useParams();

    if (typeof id === 'undefined') {
        throw new Error('id is required parameter');
    }

    const {
        record,
        loading,
        isError,
        notFound,
    } = useTestObservation(id);

    if (loading) {
        return <PlatformLoader message='Loading observation...Please wait'/>;
    }

    // Never hang on the loader once the query has settled.
    if (isError || notFound || !record) {
        return (
            <Alert color='red' title='Observation not found'>
                No observation found for id <code>{id}</code>.
            </Alert>
        );
    }

    return (
        <FormPageLayout
            title={record.actionCode}
            pageNavigation={<DetailPageNavigation component={record}/>}
        >
            <Grid>
                <Grid.Col span={{
                    base: 12,
                    lg: 6
                }}>
                    <Profile record={record}/>
                </Grid.Col>
            </Grid>
        </FormPageLayout>
    );
};
